import { useTranslation } from "next-i18next";
import ProductShareModal from "../Modal/ProductShareModal";
import { useState } from "react";
import { IProduct } from "@/props/IProduct";
import Icon from "../Icon";

/**
 * product share component
 * @param product product data
 * @param isMobile is or not mobile
 */
const ProductShare = ({
  product,
  isMobile = false,
}: {
  product: Pick<IProduct, "id" | "image" | "storeName" | "price">;
  isMobile?: boolean;
}) => {
  const { t } = useTranslation();
  const [shareModalOpen, setShareModalOpen] = useState<boolean>(false);

  return (
    <>
      <div
        className={`boder-0 right-mobile top-4 z-40 mt-0  cursor-pointer items-center justify-center self-baseline rounded border-gray-100 px-0 text-base font-medium lg:mt-3 lg:h-12 lg:border lg:px-6 ${
          !isMobile ? "hidden h-5 lg:flex" : "flex h-full lg:hidden"
        }`}
        onClick={() => {
          setShareModalOpen(true);
        }}
      >
        <div className="hidden lg:block">{t("product_detail.share")}</div>
        <Icon
          name="share-black"
          size={!isMobile ? 16 : 18}
          title="icon share"
          className="ml-2"
        />
      </div>
      <ProductShareModal
        open={shareModalOpen}
        product={product}
        onModalCancel={() => {
          setShareModalOpen(false);
        }}
      />
    </>
  );
};

export default ProductShare;
